/** @format */
import { MarketCode } from '@mpb-com/feather/enums';
import { useTranslation } from 'next-i18next';

export function useTranslatedMarketName(marketCode: MarketCode) {
    const { t } = useTranslation();

    const translatedMarketNames: Record<MarketCode, string> = {
        [MarketCode.EN_UK]: t('United Kingdom'),
        [MarketCode.EN_EU]: t('Europe (English)'),
        [MarketCode.EN_US]: t('United States'),
        [MarketCode.EN_IE]: t('Ireland'),
        [MarketCode.FR_FR]: t('France'),
        [MarketCode.FR_BE]: t('Belgium (French)'),
        [MarketCode.NL_BE]: t('Belgium (Dutch)'),
        [MarketCode.NL_NL]: t('Netherlands'),
        [MarketCode.DE_DE]: t('Germany'),
        [MarketCode.DE_AT]: t('Austria'),
        [MarketCode.IT_IT]: t('Italy'),
        [MarketCode.PT_PT]: t('Portugal'),
        [MarketCode.ES_ES]: t('Spain'),
    };

    return translatedMarketNames[marketCode];
}
